export default {
  state: {
    appStatuses: {},
  },
};
